export default __webpack_public_path__ + "static/rovio-1b3daa37a6a2b2796f9f3eb9b7e08129.svg";